import * as types from '../actions/action-types';
import _ from 'lodash';

const fields = [
  {
    field: 'od14',
    label: 'Overdose Deaths per 100k 2014',
    desc: 'Age adjusted drug overdose deaths per 100k deaths during 2014'
  },
  {
    field: 'ocPm',
    label: 'Opioid Claims per Patient 2014',
    desc: 'Average opioid prescriptions per Medicare patient during 2014'
  },
  {
    field: 'opr14',
    label: 'Opioid Prescribing Rate 2014',
    desc: 'Percent of opioid prescriptions from all Medicare claims 2014'
  },
  {
    field: 'obPct',
    label: 'Opioid Patient Percent 2014',
    desc: 'Percent of Medicare patients who were prescribed opioids during 2014'
  },
  {
    field: 'dsPm',
    label: 'Opioid Days Supply 2014',
    desc: 'Average supply days of opioids per Medicare patient during 2014'
  },
  {
    field: 'dist',
    label: 'Avg Miles to Treatment Facility',
    desc: 'Average distance in miles to nearest opioid treatment facility'
  }
];

const defaults = {
  stateKey: 'sf',
  countyKey: 'cf',
  detailKey: 'pid',

  fields: fields,

  xField: fields[0].field,
  xLabel: fields[0].label,
  xDesc: fields[0].desc,

  yField: fields[1].field,
  yLabel: fields[1].label,
  yDesc: fields[1].desc
};

/**
 * Update store based on new selected x/y dimension
 *
 * @param store
 * @param dimension
 * @param fieldName
 */
function setDimension(store, dimension, fieldName) {
  const match = _.find(fields, ['field', fieldName]);
  const field = dimension === 'x' ?
    {xField: match.field, xLabel: match.label, xDesc: match.desc} :
    {yField: match.field, yLabel: match.label, yDesc: match.desc};

  return _.assign(
    {},       // Start with new object for immutability
    store,    // Add existing store  values
    field,    // Overwrite x or y field and label properties
  );
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SELECT_FIELD:
      return setDimension(store, action.dimension, action.field);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dimensions-reducer.js